import { Cookies } from 'react-cookie';
export default new Cookies();